export default __webpack_public_path__ + "static/media/ethereum-eth-logo.dc0e7f13.svg";